import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import {
  routerReducer,
  RouterReducerState,
  StoreRouterConnectingModule,
} from '@ngrx/router-store';
import {
  StoreDevtoolsModule,
  StoreDevtoolsOptions,
} from '@ngrx/store-devtools';

import {
  GlobalAppAction,
  GlobalAuthAction,
  GlobalPermAction,
  GlobalUserAction,
} from '../stored/global/actions';
import {
  GlobalAppReducer,
  GlobalAuthReducer,
  GlobalPermReducer,
  GlobalUserReducer,
} from '../stored/global/reducers';
import {
  GlobalAppState,
  GlobalAuthState,
  GlobalPermState,
  GlobalUserState,
} from '../stored/global/states';

import { environment } from 'environments/environment';

export { GlobalAppState, GlobalAuthState, GlobalPermState, GlobalUserState };

interface NgRxState {
  Router: RouterReducerState;
  App: GlobalAppState;
  Auth: GlobalAuthState;
  Perm: GlobalPermState;
  User: GlobalUserState;
}

const NgRxReducer = {
  Router: routerReducer,
  App: GlobalAppReducer,
  Auth: GlobalAuthReducer,
  Perm: GlobalPermReducer,
  User: GlobalUserReducer,
};

const GlobalReducer = {
  routerReducer,
  GlobalAppReducer,
  GlobalAuthReducer,
  GlobalPermReducer,
  GlobalUserReducer,
};

const GlobalAction = {
  GlobalAppAction,
  GlobalAuthAction,
  GlobalPermAction,
  GlobalUserAction,
};

export { NgRxState, NgRxReducer, GlobalReducer, GlobalAction };

const storeDevOpts: StoreDevtoolsOptions = {
  maxAge: 32,
  logOnly: false,
};

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forRoot(NgRxReducer),
    StoreRouterConnectingModule.forRoot(),
    !environment.production ? StoreDevtoolsModule.instrument(storeDevOpts) : [],
  ],
  exports: [
    StoreModule,
    StoreRouterConnectingModule,
    !environment.production ? StoreDevtoolsModule : [],
  ],
})
export class AppNgrxModule {}
